import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Base_RequestHistory } from '../../Page_BaseSandbox/Base_RequestHistory/index.js';
import './Component_NLPRequestHistory.scss';
import { ModuleFE_SandboxNLP } from '../../modules/ModuleFE_SandboxNLP/index.js';
import { resolveValueDisplay } from '@app/hcs-shared';
import { MUSTNeverHappenException } from '@nu-art/ts-common';
import { DataGrid } from '@app/styles';
import { ModuleFE_Advisor_Tag, ModuleFE_Advisor_Value, ModuleFE_Advisor_Variable } from '../../../../modules/static-modules/healthcare-space.js';
export class Component_NLPRequestHistory extends Base_RequestHistory {
    getHistory() {
        return ModuleFE_SandboxNLP.getHistory();
    }
    clearHistory() {
        ModuleFE_SandboxNLP.clearHistory();
    }
    isContentResponse = (historyItem) => {
        return historyItem.type === 'received';
    };
    isContentSentMessage = (historyItem) => {
        return historyItem.type === 'sent';
    };
    formatResponseObject = (content) => {
        return content?.findings.map(finding => {
            const variable = ModuleFE_Advisor_Variable.cache.unique(finding.variableId);
            const value = ModuleFE_Advisor_Value.cache.unique(finding.valueId);
            if (!variable)
                throw new MUSTNeverHappenException(`Variable with id ${finding.variableId} not found`);
            if (!value)
                throw new MUSTNeverHappenException(`Value with id ${finding.valueId} not found`);
            return { variableName: variable.name, value: resolveValueDisplay(value) };
        });
    };
    formatSentMessageObject = (content) => {
        return {
            tags: content?.rules.map(rule => rule.tagIds).flat().map((tagId) => {
                const tag = ModuleFE_Advisor_Tag.cache.unique(tagId);
                if (!tag)
                    throw new MUSTNeverHappenException(`tag with id ${tagId} not found`);
                return tag.label;
            }),
            text: content.text
        };
    };
    prettyResponseView = (history) => {
        if (!this.isContentResponse(history))
            return _jsx("div", { children: "Invalid history message" });
        const formattedFindings = this.formatResponseObject(history.content);
        if (!formattedFindings.length)
            return _jsx("div", { style: { color: '#4f4f4f', fontSize: '14px' }, children: "No findings was returned" });
        return _jsx(DataGrid.Grid, { children: formattedFindings.map((finding, index) => {
                return _jsxs(React.Fragment, { children: [_jsx(DataGrid.Data, { children: finding.variableName }), _jsx(DataGrid.Data, { children: finding.value })] }, index);
            }) });
    };
    prettyMessageView = (history) => {
        if (!this.isContentSentMessage(history))
            return _jsx("div", { children: "Invalid history message" });
        const messageObject = this.formatSentMessageObject(history.content);
        return _jsxs(DataGrid.Grid, { children: [_jsx(DataGrid.Label, { children: "Text:" }), _jsx(DataGrid.Data, { children: messageObject.text }), _jsx(DataGrid.Label, { children: "Tags:" }), _jsx(DataGrid.Data, { children: messageObject.tags.map((tag, index) => _jsx("div", { style: { color: '#4f4f4f', fontSize: '14px' }, children: tag }, index)) })] });
    };
}
//# sourceMappingURL=Component_NLPRequestHistory.js.map